module.exports = __webpack_public_path__ + "img/1728633542694-Screenshot 32.png.faafe862.webp";